/** 处理环境变量 */
const warpperEnv = envConf => {
  /** 此处为默认值 */
  const ret = {
    VITE_PORT: 8848,
    VITE_PUBLIC_PATH: "",
    VITE_ROUTER_HISTORY: "",
    VITE_CDN: false,
    VITE_HIDE_HOME: "false",
    VITE_COMPRESSION: "none",
    VITE_PROXY_DOMAIN_REAL: "",
    VITE_PROXY_DOMAIN: "",
    VITE_SOURCE_MAP: false
  };

  for (const envName of Object.keys(envConf)) {
    let realName = envConf[envName].replace(/\\n/g, "\n");
    realName =
      realName === "true" ? true : realName === "false" ? false : realName;

    if (envName === "VITE_PORT") {
      realName = Number(realName);
    } else if (envName === "VITE_PROXY_DOMAIN_REAL") {
      realName = process.env.PROXY_TABLE_TARGET || realName;
    }
    ret[envName] = realName;
    if (typeof realName === "string") {
      process.env[envName] = realName;
    } else if (typeof realName === "object") {
      process.env[envName] = JSON.stringify(realName);
    }
  }
  return ret;
};

/** 跨域代理重写 */
const regExps = (value, reg) => {
  return value.replace(new RegExp(`^${reg}`, "g"), "");
};

/** 环境变量 */
const loadEnv = () => {
  return import.meta.env;
};
export { warpperEnv, regExps, loadEnv };
